/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RequiresToothDetails/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function RequiresToothDetails({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/Content/Claim/Content/Charges/Charge/EditInsuranceCode/Content/RequiresToothDetails",
  onChange
  
}) {
let editChargeRequiresToothDetailsValueData = fromData.useDataValue({ viewPath,
context: 'edit_charge',
path: 'requires_tooth_details',
})
let editChargeRequiresToothDetailsChangeData = fromData.useDataChange({ viewPath,
context: 'edit_charge',
path: 'requires_tooth_details',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="edit_charge.requires_tooth_details"
 value={editChargeRequiresToothDetailsValueData}
 onChange={editChargeRequiresToothDetailsChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Requires tooth # / surface"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}